import { apiRequest } from "@/services/api-client";
import { GetPlayerQueueStatusOutput, WebAppRoutes } from "types/web-app";

export const getPlayerQueueStatus = () =>
  apiRequest<GetPlayerQueueStatusOutput>(
    `/${WebAppRoutes.GET_PLAYER_QUEUE_STATUS}`,
  );
